import { render, staticRenderFns } from "./AddStageAdditionalAgreement.vue?vue&type=template&id=61ac4c0c&scoped=true"
import script from "./AddStageAdditionalAgreement.vue?vue&type=script&lang=js"
export * from "./AddStageAdditionalAgreement.vue?vue&type=script&lang=js"
import style0 from "./AddStageAdditionalAgreement.vue?vue&type=style&index=0&id=61ac4c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac4c0c",
  null
  
)

export default component.exports